import { Section } from '@advanza/advanza_generic'
import Page from 'components/ui/Page'
import React from 'react'
import AdminUserFilter from './AdminUserFilter'
import AdminUserList from './AdminUserList'
import CreateAdminUserButton from './CreateAdminUserButton'

class AdminUsersPage extends React.Component {
    render() {
        return (
            <Page title="Admin Users">
                <div className="container">
                    <Section x y>
                        <h1>Admin users</h1>
                        <Section n s="min">
                            <CreateAdminUserButton />
                        </Section>
                        <AdminUserFilter filterId="all" defaultOptions={{ active: true }} />
                        <AdminUserList filterId="all" />
                    </Section>
                </div>
            </Page>
        )
    }
}

export default AdminUsersPage
